import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Spin, Row, Col, Input, Button, Modal, Form, Layout, Table, message } from 'antd'
import { salesmanStatistic, agentDetail, auditUser, frozen } from '_src/api/api'
import './sale.less'
const { confirm } = Modal
const { Search } = Input
const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
}

class SalesStatistic extends PureComponent {
  state = {
    isLoading: false,
    modelVisible: false,
    pageData: {
      total: 0,
      current: 1,
    },
    params: {
      pageNum: 0,
      pageSize: 10,
    },
    list: [],
    columns: [
      {
        title: <span>分销用户</span>,
        align: 'center',
        dataIndex: 'userName',
        key: 'id',
      },
      {
        title: <span>手机号</span>,
        align: 'center',
        dataIndex: 'contact',
      },
      {
        title: <span>分享次数</span>,
        dataIndex: 'shares',
        align: 'center',
      },
      {
        title: <span>交易成功数</span>,
        dataIndex: 'transactions',
        align: 'center',
      },
      {
        title: <span>佣金</span>,
        render: (c) => {
          return (c.commissions / 100).toFixed(2)
        },
        align: 'center',
      },
      {
        title: <span>状态</span>,
        align: 'center',
        render: item => (
          item.status === 1
            ? <span style={{ color: '#1f922c' }}>启用中</span>
            : <span style={{ color: '#ff4447' }}>已冻结</span>
        )
      },
      {
        title: <span>操作</span>,
        align: 'center',
        render: item => (
          item.status === 1
            ? <Button type="danger" icon="disconnect" onClick={() => { this.freeze(item) }}>冻结</Button>
            : <Button type="primary" icon="check-circle" onClick={() => { this.freeze(item) }}>启用</Button>
        )
      },
    ]
  }

  componentDidMount () {
    const { params } = this.state
    this.loadList(params)
  }

  loadList = (params) => {
    this.setState({ isLoading: true })
    salesmanStatistic(params)
      .then(res => {
        this.setState({
          isLoading: false,
          list: res.data.content,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
  }

  // 冻结
  freeze = ({ status, id }) => {
    const { params } = this.state
    const title = status === 1 ? '冻结确认' : '启用确认'
    const content = status === 1 ? '确定要冻结该分销员?' : '确定要启用该分销员?'
    const self = this
    confirm({
      title,
      content,
      onOk () {
        const hide = message.loading('加载中', 0)
        const toStatus = status === 1 ? 3 : 1
        frozen({ status: toStatus, id })
          .then(res => {
            hide()
            self.setState({ isLoading: true })
            self.loadList(params)
          })
      },
      onCancel () {
        console.log('Cancel')
      },
    })
  }

  // 审核/查看
  look = (id) => {
    agentDetail({ id })
      .then(res => {
        this.setState({
          info: res.data,
          modelVisible: true,
        })
      })
  }

  // 提交审核 
  audit = (id, status) => {
    auditUser({ id, status })
      .then(res => {
        if (res) {
          this.setState({
            modelVisible: false,
            info: '',
          })
          this.loadList(this.state.params)
        }
      })
  }

  // 审核页面元素
  genModal (info) {
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form">
        <Form.Item label="名称：" className='flex'>
          <Input value={info.user.nickname} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="性别：" className='flex'>
          <Input value={info.user.gender === 1 ? '男' : '女'} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="联系方式：" className='flex'>
          <Input value={info.user.mobile} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="居住地：" className='flex'>
          <Input value={info.residence} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="职业：" className='flex'>
          <Input value={info.job} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="银行卡：" className='flex'>
          <Input value={info.bankCard} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="身份证：" className='flex'>
          <Input value={info.card} style={{ width: 178 }} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        {
          info.status === 0
            ? <Form.Item>
              <Button type="primary" htmlType="submit" icon='check' style={{ width: 100, marginLeft: 90 }} onClick={() => { this.audit(info.id, 1) }}>通过</Button>
              <Button htmlType="submit" icon='close' style={{ width: 100, marginLeft: 20 }} onClick={() => { this.audit(info.id, 2) }}>不通过</Button>
            </Form.Item>
            : ''
        }
      </Form>
    )
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.setState({ params })
    this.loadList(params)
  }

  onSearchPhone = (contact) => {
    const { params } = this.state
    params.pageNum = 0
    if (contact.length) {
      params.contact = contact
    } else {
      delete params.contact
    }
    this.setState({ params })
    this.loadList(params)
  }

  render () {
    const { isLoading, columns, list, info, modelVisible, pageData } = this.state
    return (
      <Layout className="salesman-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-inner'>
          <Row>
            <Col {...ColProps} xl={{ span: 8}} md={{ span: 8 }} className="flex-h-a">
              <span >手机号：</span>
              <Search style={{ width: 250 }} placeholder="用户手机号" onSearch={this.onSearchPhone} enterButton />
            </Col>
          </Row>
          {
            !isLoading && (
              <Table
                columns={columns}
                dataSource={list}
                bordered
                rowKey="id"
                pagination={{
                  current: pageData.current,
                  total: pageData.total,
                  pageSize: pageData.pageSize,
                }}
                onChange={this.onPageChange}
              />
            )
          }
          <Modal
            title="分销人员"
            visible={modelVisible}
            onCancel={() => {
              this.setState({
                modelVisible: false,
                info: '',
              })
            }}
            width={600}
            footer={false}
            destroyOnClose
          >
            {info ? this.genModal(info) : ''}
          </Modal>
        </div>
      </Layout>
    )
  }
}

export default connect()(SalesStatistic)